import React, { useEffect, useState } from "react";
import { Button, Form, Col, Card, Alert } from 'react-bootstrap';
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../Loader";
// import { useLocation } from "react-router-dom";

const currencyList = [
  {
    value: "cad",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/CAD.png"
          alt="CAD"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        CAD - Canadian Dollar
      </div>
    ),
  },
  {
    value: "ngn",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/NGN.png"
          alt="NGN"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        NGN - Nigerian Naira
      </div>
    ),
  },
  {
    value: "usd",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/USD.png"
          alt="USD"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        USD - US Dollar
      </div>
    ),
  },
  {
    value: "usdt",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/USDT.png"
          alt="EUR"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        USDT - USD Tether
      </div>
    ),
  },
  {
    value: "usdc",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/USDC.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        USDC - USD Coin
      </div>
    ),
  },
];

const recipientCurrencyList = [
  {
    value: "cad",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/CAD.png"
          alt="CAD"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        CAD - Canadian Dollar
      </div>
    ),
  },
  {
    value: "ngn",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/NGN.png"
          alt="NGN"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        NGN - Nigerian Naira
      </div>
    ),
  },
  {
    value: "usd",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/USD.png"
          alt="USD"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        USD - US Dollar
      </div>
    ),
  },
  {
    value: "usdt",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/USDT.png"
          alt="EUR"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        USDT - USD Tether
      </div>
    ),
  },
  {
    value: "usdc",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/USDC.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        USDC - USD Coin
      </div>
    ),
  },
  {
    value: "myr",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/MYR.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        MYR - Malaysian Ringgit
      </div>
    ),
  },
  {
    value: "inr",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/INR.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        INR - Indian Rupee
      </div>
    ),
  },
  {
    value: "vnd",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/VND.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        VND - Vietnamese đồng
      </div>
    ),
  },
  {
    value: "sgd",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/SGD.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        SGD - Singapore dollar
      </div>
    ),
  },
  {
    value: "aed",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/AED.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        AED - AE dirham
      </div>
    ),
  },
  {
    value: "cny",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/CNY.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        CNY - CN Yuan
      </div>
    ),
  },
  {
    value: "gbp",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/GBP.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        GBP - UK Pound Sterling
      </div>
    ),
  },
  {
    value: "eur",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/EUR.png"
          alt="RMB"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        EUR - EU Euro
      </div>
    ),
  },
  {
    value: "bdt",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="./Images/BDT.png"
          alt="BDT"
          style={{ marginRight: "10px", borderRadius: "50%", width: "30px", height: "30px" }}
        />
        BDT - Bangladeshi Taka
      </div>
    ),
  },
];

const options2 = [
  {
    value: "Effortless Global Payments",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        Effortless Global Payments
      </div>
    ),
  },
  {
    value: "Apply for Letter of Credit (LC)",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        Apply for Letter of Credit (LC)
      </div>
    ),
  },
  {
    value: "Tuition Payments for Canada",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        Tuition Payments for Canada
      </div>
    ),
  },
  {
    value: "Real Estate Investment Payments",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        Real Estate Investment Payments
      </div>
    ),
  },
];

const AddUserRequestQuote = (props) => {
  // const location = useLocation();
  const [loader, setLoader] = useState(false);
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  // const serviceName = location?.pathname?.split('?')[1];
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
    watch,
    setValue
  } = useForm({
    defaultValues: {
      recipientAmount: null,
      recipientCurrency: null,
      currency: null,
      service: null,
    }
  });

  const handleAddQuote = (data) => {
    setLoader(true);
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/quotation/`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      data: JSON.stringify({
        userId: user._id,
        serviceType: data.service.value,
        recipientAmount: data.recipientAmount,
        currency: data.currency.value,
        recipientCurrency: data.recipientCurrency.value,
        amountToSend: data.amountToSend,
      }),
    }).then(res => {
      setLoader(false);
      toast(res.data.message || "Your quotation request has been successfully submitted", {
        type: "success",
        position: "top-right",
        theme: "light",
      })
      reset();
      props.onSubmit();
    }).catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        toast(err.response.data.errors?.[0].msg || "Failed to add quotation", {
          type: "error",
          position: "top-right",
          theme: "light",
        });
      } else {
        toast(err?.response?.data?.message || err.message || "Failed to add quotation", {
          type: "error",
          position: "top-right",
          theme: "light",
        });
      }
    });
  }

  useEffect(() => {
    if (watch("service")?.value === "Apply for Letter of Credit (LC)") {
      setValue("recipientCurrency", recipientCurrencyList.find(f => f.value === "usd"));
    }
  }, [watch("service")]);

  return (
    <>
      <Col lg={6} md={12}>
        <Card className="bg-white p-lg-5 p-4 h-100">
          <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
            <div className="head_title">
              <h3 className="mb-0">Request for a Quotation</h3>
            </div>
          </div>
          <Form onSubmit={handleSubmit(handleAddQuote)}>
            <Form.Group className="mb-3" controlId="service">
              <Form.Label>Service <span>*</span></Form.Label>
              <Controller
                name="service"
                control={control}
                rules={{
                  required: { message: "Service is require", value: true }
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      options={options2}
                      placeholder="Select service"
                    />
                  )
                }} />
              {errors.service ? <p className="errMsg">{errors.service.message}</p> : null}
            </Form.Group>

            <Form.Group className="mb-3" controlId="currency">
              <Form.Label>Your Currency <span>*</span></Form.Label>
              <Controller
                name="currency"
                control={control}
                rules={{
                  required: { message: "Currency is require", value: true }
                }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={currencyList.filter(f => f.value !== watch("recipientCurrency")?.value || "")}
                    placeholder="Select your currency"
                  />
                )} />
              {errors.currency ? <p className="errMsg">{errors.currency.message}</p> : null}
            </Form.Group>

            <Form.Group className="mb-3" controlId="RecipientCurrency">
              <Form.Label>Recipient Currency <span>*</span></Form.Label>
              <Controller
                name="recipientCurrency"
                control={control}
                rules={{
                  required: { message: "Recipient currency is require", value: true }
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      options={
                        watch("service")?.value === "Apply for Letter of Credit (LC)" ?
                          recipientCurrencyList.filter(f => f.value == "usd")
                          : recipientCurrencyList.filter(f => f.value !== watch('currency')?.value || "")
                      }
                      placeholder="Select recipient currency"
                    />
                  )
                }} />
              {errors.recipientCurrency ? <p className="errMsg">{errors.recipientCurrency.message}</p> : null}
            </Form.Group>

            <Form.Group className="mb-3" controlId="RecipientAmount">
              <Form.Label>Recipient Amount <span>*</span></Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter recipient amount"
                {...register("recipientAmount", {
                  required: { message: "Recipient amount is require", value: true },
                  pattern: { message: "Recipient amount is not valid", value: /^[0-9]*\.?[0-9]{0,10}$/ }
                })} />
              {errors.recipientAmount ? <p className="errMsg">{errors.recipientAmount.message}</p> : null}
            </Form.Group>

            <Button onClick={handleSubmit(handleAddQuote)} className="button yellow" variant="primary" type="submit"> Submit </Button>
          </Form>

          <Alert key="warning" variant="warning" className="mb-0 mt-4">
            Kindly scroll down to view the quotations.
          </Alert>

        </Card>
      </Col>
      <Col lg={6} md={12} className="mb-lg-0 mb-4">
        <Card className="bg-white p-lg-5 p-4 h-100">
          <div className="d-flex align-items-center justify-content-between gap-3">
            <div className="head_title">
              <h3 className="mb-4">How It Works</h3>
            </div>
          </div>
          <ul className="work_content">
            <li>
              <span>1</span>
              <h6>Request a Quote</h6>
              <p>Request a quote to receive today’s rate and the expiration time. Once accepted, the order process begins. Rates depend on quantity, with larger orders typically receiving better rates, and all fees included.</p>
            </li>
            <li>
              <span>2</span>
              <h6>Make Payment</h6>
              <p>Pay using the provided bank details and upload proof of payment along with the recipient's details. You’ll receive a confirmation notification once verified.</p>
              <p className="text-danger">Please Note : No third-party payments are allowed, and ensure you complete the one-time KYC process before making any payments.</p>
            </li>
            <li>
              <span>3 </span>
              <h6>We Pay the Recipient</h6>
              <p>We process the payment to the recipient in their currency and provide you with a receipt once completed.</p>
            </li>
            {"Apply for Letter of Credit (LC)" === watch("service")?.value ?
              <li>
                <span>4 </span>
                <h6>Letter of Credit Transaction fee :</h6>
                <p>
                  <ul>
                    <li>a. For transaction below $60k: 850 x rate = Transaction fee</li>
                    <li>b. For transaction above $60K: $450 + (amount)0.75% = Transaction Fee</li>
                  </ul>
                </p>
              </li>
              : null}
          </ul>
        </Card>
      </Col>
      <Loader show={loader} />
    </>
  )
}

export default AddUserRequestQuote